export enum BuildMode {
  Development = "development",
  Beta = "beta",
  Production = "production",
}

/**
 * Single source of truth for the build mode. nuxt.config.ts injects it explicitly via
 * `__BUILD_MODE__` (`vite.define`), because under Nuxt `import.meta.env.MODE`/`PROD`
 * always resolve to "production" regardless of BUILD_MODE.
 */
export const buildMode = __BUILD_MODE__;

export const isProduction = buildMode === BuildMode.Production;
